import { ContactMeActions } from './ContactMeActions';

const contactMeReducer = (state, action) => {
  let contactMe = state.contactMe || {
    searchForLocationMatch: true,
  };

  switch (action.type) {
    case ContactMeActions.CONTACTME_LEAD_UPDATED: {
      contactMe.contactLead = action.contactLead;
      contactMe.isProcessing = false;
      break;
    }

    case ContactMeActions.APPOINTMENT_LOCATION_SEARCH_UPDATED: {
      contactMe.locationSearchForm = action.locationSearchForm;
      break;
    }

    case ContactMeActions.APPOINTMENT_LOCATION_SELECTED: {
      contactMe.selectedLocation = action.location;
      break;
    }

    case ContactMeActions.APPOINTMENT_LOCATIONS_UPDATED: {
      contactMe.searchForLocationMatch = false;
      contactMe.availableLocations = action.availableLocations;
      contactMe.isProcessing = false;
      break;
    }

    case ContactMeActions.APPOINTMENT_TIMESLOT_SELECTED: {
      contactMe.selectedTime = action.time;
      break;
    }

    case ContactMeActions.APPOINTMENT_TIMESLOTS_UPDATED: {
      contactMe.availableTimeSlots = action.availableTimeSlots;
      contactMe.isProcessing = false;
      break;
    }

    case ContactMeActions.APPOINTMENT_BOOKING_COMPLETE: {
      contactMe.appointment = action.appointment;
      contactMe.isProcessing = false;
      break;
    }

    case ContactMeActions.CONTACTME_LEAD_UPDATE_STARTED:
    case ContactMeActions.APPOINTMENT_LOCATIONS_UPDATE_STARTED:
    case ContactMeActions.APPOINTMENT_TIMESLOTS_UPDATE_STARTED:
    case ContactMeActions.APPOINTMENT_BOOKING_STARTED: {
      contactMe.isProcessing = true;
      break;
    }

    case ContactMeActions.REMOTE_SESSION_CREATE_DONE: {
      contactMe.hasFinishedCreatingRemoteSession = true;
      break;
    }

    case ContactMeActions.REMOTE_SESSION_COMPLETED_REQUEST_DONE: {
      contactMe.hasFinishedCompletingRemoteSession = true;
      const remoteSessionAppkey = 'remoteSessionCompleted';
      const remoteSessionAnswer = state.answers[remoteSessionAppkey] || {};
      return {
        ...state,
        contactMe,
        answers: {
          ...state.answers,
          ['remoteSessionCompleted']: {
            appkey: remoteSessionAppkey,
            timestamp: new Date(),
            value: Math.floor(Math.random() * Math.floor(99999)),
            ...remoteSessionAnswer,
          },
        },
      };
    }

    default:
      return state;
  }

  return {
    ...state,
    contactMe,
  };
};

export default contactMeReducer;
